import { TbNotebook } from 'react-icons/tb';
import type { IconProps } from './IconBase';
import { IconBase } from './IconBase';

export const NotebookIcon = (props: IconProps) => {
  return <IconBase icon={TbNotebook} {...props} />;
};
